import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { StockPropertyHeader } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class StockPropertyHeaderService extends TmsWebBaseEditService<StockPropertyHeader, StockPropertyHeader> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('StockPropertyHeader', $localize`Stock Property Header`);
  }
}
